export class MoreAboutObservationcancel {
  fullnameCancellator: string;
}
